
module.exports = (n) => (new Array(n)).fill(0).map((x, i) => i);



// WEBPACK FOOTER //
// ./src/range.js